import { Injectable } from '@angular/core';
import { DataService } from 'src/app/shared/session';
import { SessionInfo } from 'src/app/shared/session/SessionInfo';
import { Zona } from './zona.model';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ZonaService {

  constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }

  private insertarZonaUrl: string = 'zona/insertar';
  private actualizarZonaUrl: string = 'zona/actualizar';
  private obtenerZonaUrl: string = 'zona/obtener';
  private listarZonaPorUrl: string = 'zona/listarPor';

  insertarZona(zona: Zona): any {
    let parameters: string;
    parameters = JSON.stringify({
      nombre: zona.nombre,
      idEmpresa: this.sessionInfo.getEmpresaID(),
      userCreation: this.sessionInfo.getCodUsuario(),
    });
    this.dataService.set(this.insertarZonaUrl);
    return this.dataService.execPostJson(parameters);
  }

  actualizarZona(zona: Zona): any {
    let parameters: string;
    parameters = JSON.stringify({
      id: zona.id,
      nombre: zona.nombre,
      userLastUpdate: this.sessionInfo.getCodUsuario(),
    });
    this.dataService.set(this.actualizarZonaUrl);
    return this.dataService.execPostJson(parameters);
  }

  obtenerZona(id: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pKey", String(id));
    this.dataService.set(this.obtenerZonaUrl);
    return this.dataService.execGetJson(parameters);
  }

  listarZona(filtro: string): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", filtro);
    parameters = parameters.append("idEmpresa", String(this.sessionInfo.getEmpresaID()));
    this.dataService.set(this.listarZonaPorUrl);
    return this.dataService.execGetJson(parameters);
  }
}
